import React from 'react';
import ReactDOM from 'react-dom';
import '../misc/axios-config';
import App from '../info/App';

require('../css/legantia.scss');
import('../misc/base.js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-js-info]').forEach((el) => {
    let config = JSON.parse(el.dataset.jsInfo || '{}');
    config.stepContent = Array.from(el.querySelectorAll('[data-js-info-step]'))
      .map((el) => [el.dataset.jsInfoStep, el.innerHTML])
      .reduce((obj, item) => {
        const [k, v] = item;
        return {
          ...obj,
          [k]: v
        };
      }, {});

    ReactDOM.render(<App config={config} />, el);
  });
});

document.querySelector('meta[name=theme-color]')?.setAttribute('content', '#232847');

document.querySelectorAll('a[data-fakelink]').forEach((el) => {
  let jsapp = document.querySelector('[data-js-info]');
  el.addEventListener('click', (e) => {
    e.preventDefault();
    jsapp.scrollIntoView({ block: 'start', behavior: 'smooth' });
    setTimeout(() => {
      jsapp.querySelector('input')?.focus();
    }, 1300);
  });
});
